import RandExp from 'randexp';

export const toISOLocal = (d: Date): string => {
  const z = (n: number) => `0${n}`.slice(-2);
  const zz = (n: number) => `00${n}`.slice(-3);
  let off = d.getTimezoneOffset();
  off = Math.abs(off);

  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}T${z(
    d.getHours(),
  )}:${z(d.getMinutes())}:${z(d.getSeconds())}.${zz(d.getMilliseconds())}Z`;
};

export const generateId = (): string => {
  const regex = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;

  return new RandExp(regex).gen();
};

export const missionTypeRegisterEducation = [
  'AMC itinerante',
  'AMC nas escolas',
  'AMC nos bares',
  'Bike sem barreiras',
  'Capacitação',
  'Ciclofaixa de lazer',
  'Ciclofaixa segura',
  'Comando de saúde',
  'Comando educativo',
  'Curso de pilotagem segura para ciclista',
  'Curso de pilotagem segura para motociclista',
  'Palestra',
  'Passeio ciclístico',
  'Um dia de trânsito',
];

export const missionFocusRegisterEducation = [
  'Apoio a evento',
  'Captação',
  'Ciclistas',
  'Crianças',
  'Geral',
  'Idosos/PcD',
  'Lei Seca',
  'Motociclistas',
  'Ocupantes de automóveis',
  'Outros',
  'Pedestres',
  'Ponto cego caminhão',
  'Ponto cego onibus',
  'Público interno',
  'Transporte de pet',
  'Volta às aulas',
];

export const suportTeam: string[] = [
  'Polícia Rodoviária Federal (PRF)',
  'Guarda Municipal de Fortaleza (GMF)',
  'Polícia Militar',
  'Gerência de Educação no Trânsito',
  'Outro',
];

export const genero: string[] = [
  'Ciclista homem',
  'Ciclista mulher',
  'Condutor homem',
  'Condutora mulher',
  'Criança',
  'Geral',
  'Homem',
  'Idoso(a)',
  'Motociclista homem',
  'Motociclista mulher',
  'Mulher',
  'Outros',
  'Pedestre homem',
  'Pedestre mulher',
];

export const MateriaisUtilizadosType: string[] = [
  'Panfleto',
  'Placa reflexiva',
  'Brinde adulto',
  'Brinde infantil',
  'Corta-pipa',
  'Adesivo',
  'Camisa',
  'Led',
  'Laço amarelo',
  'Lanche',
  'Credencial',
  'Boné',
  'Pin',
  'Óculos alcoolemia',
  'Manga protetiva',
  'Ônibus',
  'Van',
  'Moto',
  'Carro',
  'Cones',
  'Mini circuito',
  'Bicicletas',
  'Outros',
];

export const MateriaisUtilizadospecification: string[] = [
  'Não informado',
  'Bebida e direção',
  'Ciclista',
  'Motociclista',
  'Maio amarelo',
  'Ciclista homem',
  'Ciclista mulher',
  'Ciclista mãe',
  'Ciclistinha',
  'Pedestre',
  'Idoso',
  'PcD',
  'Pet',
  'Ponto cego',
  'Geral',
];

export const AtividadesRealizadasType: string[] = [
  'Captação',
  'Contação de estória',
  'Credencial de idoso/PcD',
  'Dinâmica de grupo',
  'Jogo de tabuleiro',
  'Jogo educativo',
  'Orientação',
  'Palestra',
  'Teatro de fantoche',
  'Vivência em circuito',
  'Outros',
];

export const EquipeFuncao: string[] = [
  'Apoio Operacional',
  'Balizador(a)',
  'Coordenador(a)',
  'Educador(a)',
];

export const EquipeCargo: string[] = ['Agente', 'Equipe Interna', 'Via Livre'];
